import classNames from 'classnames';
import React from 'react';
function PlaceholderContainer({
  children,
  className,
  'data-testid': dataTestId
}: {
  children: React.ReactNode;
  className?: string;
  'data-testid'?: string;
}) {
  return (
    <div
      data-testid={dataTestId}
      className={classNames(
        'flex flex-col items-center justify-center pt-huge pb-xl pl-xxl pr-xxl gap-xl w-full',
        className
      )}
    >
      {children}
    </div>
  );
}

export default PlaceholderContainer;
